import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
import InstantSearch from 'vue-instantsearch';
import JsonContentEditorModule from './modules/JsonContentEditorModule/JsonContentEditorModule';
import MediaGalleryModule from './modules/MediaGallery/MediaGalleryModule';
import MediaUploadComponent from './components/MediaUpload/MediaUploadComponent';
import MassAssignMediaUploadComponent from './components/MassAssignMediaUpload/MassAssignMediaUploadComponent';
import MediaList from './components/MediaList/MediaListComponent';
import MetaData from './components/MetaData/MetaDataComponent';
import AttachProductAdditionalData from './components/AttachProductAdditionalData/AttachProductAdditionalData';
import AttachProductGroupAdditionalData from './components/AttachProductGroupAdditionalData/AttachProductGroupAdditionalData';
import ProductSearch from './components/ProductSearch/ProductSearchComponent';
import GlobalHeaderSearch from './components/GlobalHeaderSearch/GlobalHeaderSearch';

/*
|--------------------------------------------------------------------------------------------------
| Global loader
| Usage:
| ~ window.loader.show()
| ~ window.loader.hide()
|--------------------------------------------------------------------------------------------------
*/

window.loader = (() => {
  const element = $('.global-loader');

  function show() {
    element.show();
  }

  function hide() {
    element.hide();
  }

  return {
    show,
    hide,
  };
})();


Vue.use(InstantSearch);
Vue.use(VueFroala);
Vue.component('media-upload-component', MediaUploadComponent);
Vue.component('mass-assign-media-upload-component', MassAssignMediaUploadComponent);

const app = new Vue({
  el: '#app',

  components: {
    JsonContentEditorModule,
    MediaGalleryModule,
    MediaList,
    MetaData,
    AttachProductAdditionalData,
    AttachProductGroupAdditionalData,
    ProductSearch,
    GlobalHeaderSearch,
  },
});
